export const APPLY_FOR_INVITE_URL = 'https://gfhr.typeform.com/apply';
